"use strict";

const HardAssetInventoryMonitoringScreening = function () {
  const stringKey = "hard-asset-monitoring-screening";
  const headerInformation = "Monitoring & Screening";
  let $page;

  var getStringKey = function () {
    return stringKey;
  };

  var getHeaderInformation = function () {
    return headerInformation;
  };

  var render = async function () {
    renderPageHtml();
    loadListeners();
  };

  var renderPageHtml = function () {
    const html = nunjucks.render("modals/wqInventory/assetInventoryMonitoringScreening.njk", {
      ...HardAssetInventoryModalController.getInventoryForRender(),
      locationPhaseOptions: SamplingSiteInventoryConstants.getSitePhaseOptions(),
    });
    HardAssetInventoryModalController.renderPageContent(html);
    $page = $(".modal-dynamic-content");
  };

  var loadListeners = function () {
    $page.on("change", `[name="location-phase"]`, onLocationPhaseChange);

    Form.initializeAndLoadListeners(
      $page,
      HardAssetInventoryModalController.getInventoryFormKey(),
      { isMultiPart: true },
    );
  };

  var removeListeners = function () {
    $page.off("change", `[name="location-phase"]`, onLocationPhaseChange);
  };

  var onLocationPhaseChange = function () {
    const locationPhase = HardAssetInventoryModalController.getLatestData("locationPhase");
    $page.find(".inactive-date legend").toggleClass("required", locationPhase === "inactive");
  };

  var validate = function () {
    const locationPhase = HardAssetInventoryModalController.getLatestData("locationPhase");
    const locationInactiveDate =
      HardAssetInventoryModalController.getLatestData("locationInactiveDate");

    if (locationPhase === "inactive" && !locationInactiveDate) {
      MessageModal.showSimpleWarningModal("<p>Please enter a valid inactive date.</p>", true);
      return false;
    }

    return true;
  };

  var cleanUp = function () {
    removeListeners();
    $page.empty();
    return true;
  };

  return {
    getStringKey,
    getHeaderInformation,
    render,
    cleanUp,
    validate,
  };
};

module.exports = HardAssetInventoryMonitoringScreening();

const Form = require("../../general/form");
const MessageModal = require("../../modals/messageModal");
const SamplingSiteInventoryConstants = require("../../wq/samplingSiteInventoryConstants");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
